import Config from '../../config/index';
import * as FrontCubeData from '../../frontCubeData/index';

// 计算警告列表
export function makeWarningList(cube: CubeNode): Array<string> {
    let enumData: Array<FreeObjMap> = Config.getGlobalConfig('ERROR_ENUM');
    let map: FreeObjMap = {};
    let checkError: Array<FreeObjMap> = FrontCubeData.getValue(cube.id, 'warningEnumSet');
    let result: Array<string> = [];

    enumData.forEach(function(e) {
        map[e.enumId] = e;
    });
    checkError.forEach((item) => {
        if (map[item.key] && map[item.key].status + '' === '1') {
            result.push(item.value);
        }
    });

    return result;
}

// 警告文案组装
export function pieceWarningStr(warningList: Array<string>): string {
    let result: string = '';

    for (var i: number = 0; i < warningList.length; i++) {
        result += warningList[i];
    }

    return result;
}
